export const SelectedListService = Symbol.for('SelectedListService');
